// import: styles
import { Box } from '@mui/material';
import { ROOT } from 'navigation/Routes.ts';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { errorPageStyles } from 'layouts/pages/error-page/ErrorPageStyles';
import BaseTypography from 'components/typography/BaseTypography';
import BaseButton from 'components/button/BaseButton';

// import: assets
// import: constants
// import: utils
// import: services
// import: redux
// import: components

export default function ErrorPage() {
	const navigate = useNavigate();

	const backToHome = () => {
		navigate(ROOT);
	};

	return (
		<Box id="error-page" sx={[errorPageStyles.page]}>
			<Box id="text-content-cont" sx={[reusableStyles.flexCol, { gap: '16px' }]}>
				<BaseTypography variant="h1_medium" style={errorPageStyles.title}>
					404
				</BaseTypography>
				<BaseTypography variant="h1_medium" style={errorPageStyles.subtitle}>
					Page not found
				</BaseTypography>
			</Box>
			<BaseButton id="back-to-home" styles={errorPageStyles.backToHomeButton} onClick={backToHome}>
				Back to Home
			</BaseButton>
		</Box>
	);
}
